import { createElement, lazy } from "react";
import { Outlet, useOutlet } from "react-router-dom";
import NotFound from "../app/not-found";

const pageModules = require.context("../app", true, /page\.js$/, "lazy");
const layoutModules = require.context("../app", true, /layout\.js$/);
const root = { children: new Map() };

function getNode(segments) {
  return segments.reduce((parent, segment) => {
    if (!parent.children.has(segment)) {
      parent.children.set(segment, { segment, children: new Map() });
    }
    return parent.children.get(segment);
  }, root);
}

function getDirectorySegments(file, filename) {
  const directory = file.slice(2, -filename.length);
  return directory.split("/").filter(Boolean);
}

for (const file of layoutModules.keys()) {
  const segments = getDirectorySegments(file, "layout.js");
  if (segments.length) {
    getNode(segments).layout = layoutModules(file).default;
  }
}

for (const file of pageModules.keys()) {
  const segments = getDirectorySegments(file, "page.js");
  const node = getNode(segments);
  node.page = lazy(() => pageModules(file));
}

function toRoutePath(segment) {
  if (segment.startsWith("(") && segment.endsWith(")")) return null;
  const dynamic = segment.match(/^\[([^\]]+)\]$/);
  if (dynamic) return `:${dynamic[1]}`;
  if (segment.includes("[") || segment.includes("]")) {
    throw new Error(`Unsupported route segment: ${segment}`);
  }
  return segment;
}

function LayoutRoute({ Layout }) {
  return createElement(Layout, null, useOutlet());
}

function buildRoute(node) {
  const childRoutes = Array.from(node.children.values(), buildRoute);
  const route = {};
  const path = node.segment ? toRoutePath(node.segment) : null;

  if (path !== null) route.path = path;
  if (node.layout) {
    route.element = createElement(LayoutRoute, { Layout: node.layout });
  } else if (node.page && childRoutes.length) {
    route.element = createElement(Outlet);
  }

  if (node.page) {
    const pageRoute = { index: true, element: createElement(node.page) };
    if (node.layout || childRoutes.length) {
      childRoutes.unshift(pageRoute);
    } else {
      route.element = pageRoute.element;
    }
  }

  if (childRoutes.length) route.children = childRoutes;
  return route;
}

const routes = Array.from(root.children.values(), buildRoute);
if (root.page) routes.unshift({ index: true, element: createElement(root.page) });
routes.push({ path: "*", element: createElement(NotFound) });

export { routes };
